import AppDispatcher from '../utils/AppDispatcher';
import { EventEmitter } from 'events';

import { actions as GuestActions } from '../constants/GuestConstants';
import { actions as PosActions } from '../constants/PosConstants';

import { events as GuestEvents } from '../constants/GuestConstants';

var _state = {
    guest : [],
    showCollector: true,
}

class GuestStoreClass extends EventEmitter {

    getState() {
        return _state;
    }

    getGuestById(guest_id) {
        for (var i=0; i<_state.guest.length; i++) {
            if (_state.guest[i].Guest_id == guest_id)
                return _state.guest[i];
        }

        return false;
    }

    selectedGuestId() {
        return _state.selectedGuestId;
    }

    selectGuest(guestId) {
        _state.selectedGuestId = guestId;
    }

    showCollector(val) {
        _state.showCollector = val;
        this.emitChange(val)
    }

    addGuest(guest) {
        var match = false;
        for (var i=0; i<_state.guest.length; i++) {
            if (_state.guest[i].Guest_id == guest.Guest_id) {
                guest.printedAllLabels = _state.guest[i].printedAllLabels;
                _state.guest[i] = guest;
                match = true;
            }
        }

        if (!match)
            _state.guest.push(guest);

        this.emitChange(guest);
    }

    updateTransactionReference(shipmentId, TransactionReference) {
        var found = false;

        for (var i=0; i<_state.guest.length; i++) {
            if (_state.guest[i].ShipmentId === shipmentId) {
                _state.guest[i].TransactionReference = TransactionReference;
                found = true;
            }
        }

        if(found) {
            this.emitChange();
        }
    }

    emitChange(callback) {
        this.emit(GuestEvents.CHANGE_EVENT, callback)
    }

    addChangeListener(callback) {
        this.on(GuestEvents.CHANGE_EVENT, callback)
    }

    removeChangeListener(callback) {
        this.removeListener(GuestEvents.CHANGE_EVENT, callback)
    }
}

const GuestStore = new GuestStoreClass();

GuestStore.dispatchToken = AppDispatcher.register(action => {

    switch(action.actionType) {

        case GuestActions.GUEST_LOADED:
            GuestStore.addGuest(action.data);
            break;

        case PosActions.TRANSACTION_REFERENCE_UPDATED: 
            GuestStore.updateTransactionReference(action.data.ShipmentId, action.data.TransactionReference);
            break;
        case PosActions.ALL_LABELS_PRINTED: 
            var guest = GuestStore.getGuestById(action.data.Guest_id);
            guest.printedAllLabels = true;
            //GuestStore.emitChange(guest);
            break;
    }
});

export default GuestStore;



// WEBPACK FOOTER //
// ./ui_src/app/stores/GuestStore.jsx